import { TabPanel } from 'common/components/TabPanel/TabPanel'
import { DocumentsTable } from 'features/Home/Book/Booking/Documents/DocumentsTable/DocumentsTable'
import { useLazyFetchPromotionsDocumentsQuery } from 'features/Home/Promotion/state/promotionsApi'
import { BillingHistory } from 'features/Profile/features/BillingHistory/BillingHistory'
import { type FC, memo, useEffect, useMemo } from 'react'
import { Navigate, useParams } from 'react-router'
import { PATH_SEGMENT } from 'routes/pathSegments'
import { generateRouter, PathUtils } from 'routes/routes.utils'

type Props = {
  isPromotion?: boolean
}
export const Documents: FC<Props> = memo(({ isPromotion = false }) => {
  const { bookingId, siteId } = useParams()

  const [fetchDocuments, { data, isLoading }] = useLazyFetchPromotionsDocumentsQuery()

  const tabs = useMemo(
    () => [
      {
        path: PATH_SEGMENT.CONTRACTS,
        title: 'Contracts',
      },
      {
        path: PATH_SEGMENT.BILLING,
        title: 'Billing',
      },
    ],
    [],
  )

  const routesConfig = useMemo(
    () => ({
      [PATH_SEGMENT.CONTRACTS]: <DocumentsTable data={data} isLoading={isLoading} />,
      [PATH_SEGMENT.BILLING]: <BillingHistory bookingId={bookingId} />,
      [PATH_SEGMENT.ROOT]: (
        <Navigate
          to={
            isPromotion
              ? PathUtils.getPromotionContracts(siteId, bookingId)
              : PathUtils.getBookingContracts(siteId, bookingId)
          }
          replace
        />
      ),
    }),
    [data, isLoading, bookingId, isPromotion, siteId],
  )

  useEffect(() => {
    if (!bookingId || !siteId) {
      return
    }

    fetchDocuments({ bookingId, siteId })
  }, [bookingId, siteId])

  return (
    <>
      <TabPanel tabs={tabs} />
      {generateRouter(routesConfig)}
    </>
  )
})
